import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import {
  useQueryGetClassroomAverageByUnit,
  useQueryGetCourseUnits,
} from "@examspark/common-app";
import { Button } from "@examspark/common-ui";
import { IconRedirectLine } from "@examspark/common-ui/dist/components/icons";
import { ParsedClassroom, ParsedTCMPCUnit } from "@examspark/types";

import SetupPrompt from "../common/SetupPrompt";
import CourseProgress from "../course/CourseProgress";
import UnitSummary from "../unit/UnitSummary";

const StyledProgress = styled.div`
  display: contents;
  grid-area: progress;
`;

const ClassroomOverview = (props: { classroom: ParsedClassroom }) => {
  const navigate = useNavigate();
  const { data: scoresByUnit } = useQueryGetClassroomAverageByUnit(
    props.classroom.id,
  );

  const { data: courseUnits } = useQueryGetCourseUnits(
    props.classroom.courseId,
  );

  console.log("classroom", props.classroom);
  console.log("scores", scoresByUnit);

  return (
    <>
      {props.classroom?.course && (
        <>
          {courseUnits != null && (
            <StyledProgress>
              <CourseProgress
                classroom={props.classroom}
                scoresByUnit={scoresByUnit}
                currentUnitId={props.classroom?.unitId}
              />
            </StyledProgress>
          )}
          {!props.classroom.unit && (
            <SetupPrompt>
              <div>
                <SetupPrompt.Title>
                  Which Unit / Module are You Teaching?
                </SetupPrompt.Title>
              </div>
              <div>
                <Button
                  title="Go To Unit / Module Details"
                  variant="outlined"
                  onClick={() => navigate("units")}
                  icon={<IconRedirectLine />}
                >
                  Set My Current Unit
                </Button>
              </div>
            </SetupPrompt>
          )}
          {props.classroom.unit && (
            <UnitSummary unit={props.classroom?.unit as ParsedTCMPCUnit} />
          )}
        </>
      )}
    </>
  );
};

export default ClassroomOverview;
